export const normalizeUploadedUrls = (
	urls: string[] | Iterable<string> | null | undefined
): string[] => {
	if (!urls) {
		return [];
	}
	return Array.from(urls).map(u => (u || '').trim()).filter(Boolean);
};
